import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const FilePdfIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path fill="#DA3737" d="M0 0h24v24H0z" />
        <path
          d="M11.507 10.853c-.307.987-.747 2.04-1.347 3.2-.266.507-.56.987-.666 1.387l.146-.053a25.154 25.154 0 0 1 4.454-1.24c-.2-.134-.387-.28-.547-.427-.8-.68-1.493-1.667-2.04-2.867zm8.64 5.08c-.227.254-.627.4-1.213.4-1.014 0-2.667-.306-4-.986-2.294.253-4 .56-5.374 1-.066.026-.146.053-.24.093-1.653 2.827-2.88 4.093-3.96 4.093-.213 0-.426-.053-.586-.146l-.64-.414-.04-.066a1.211 1.211 0 0 1-.067-.72c.147-.707.907-1.827 2.507-2.827.253-.187.653-.4 1.187-.653.4-.694.826-1.507 1.28-2.4.68-1.374 1.106-2.734 1.44-3.907v-.013c-.494-1.614-.787-2.587-.294-4.36C10.267 4.52 10.707 4 11.2 4h.32c.307 0 .6.107.814.32.88.88.466 3.027.026 4.8-.026.08-.04.147-.053.187.533 1.506 1.293 2.72 2.133 3.413.347.267.734.533 1.16.773.6-.066 1.174-.093 1.72-.093 1.654 0 2.654.293 3.04.92.134.213.2.467.16.733-.013.334-.133.64-.373.88zm-.547-.946c-.133-.134-.666-.467-2.533-.467-.093 0-.187 0-.307.133.974.427 1.92.68 2.534.68.093 0 .173-.013.253-.026h.053c.067-.027.107-.04.12-.174-.026-.04-.053-.093-.12-.146zM7.374 16.933c-.28.16-.507.307-.64.414-.947.866-1.547 1.746-1.613 2.253.6-.2 1.386-1.08 2.253-2.667zM11.4 7.72l.067-.053c.093-.427.133-.8.213-1.094l.04-.213c.134-.76.107-1.147-.12-1.467l-.2-.066a1.7 1.7 0 0 0-.093.16c-.227.56-.213 1.533.093 2.733z"
          fill="#FFF"
        />
      </g>
    </SvgIcon>
  );
};
